import { TermsComponent } from './terms/terms.component';

export const containers: any[] = [TermsComponent];

export * from './terms/terms.component';
